import { render, staticRenderFns } from "./AsetItem.vue?vue&type=template&id=e17bc830&"
import script from "./AsetItem.vue?vue&type=script&lang=js&"
export * from "./AsetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports